import React, { useState, useEffect } from "react";
import { getAuth, updateProfile, onAuthStateChanged } from "firebase/auth";
import { ImSpinner8 } from "react-icons/im";
import { FaUser, FaCheckCircle, FaArrowRight } from "react-icons/fa"; // Swapped FaRocket for FaArrowRight
import { useNavigate } from "react-router-dom";

const auth = getAuth();

function Onboarding() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const handleProfileUpdate = async (e) => {
    e.preventDefault(); 
    setIsLoading(true);
    setErrorMessage("");

    if (!username) {
      setErrorMessage("Field cannot be empty");
      setIsLoading(false);
      return;
    }

    if (username.trim().length < 3) {
      setErrorMessage("Username must be at least 3 characters long");
      setIsLoading(false);
      return;
    }

    try {
      await updateProfile(auth.currentUser, { displayName: username.trim() });
      setShowPopup(true);
    } catch (error) {
      console.error("Error updating profile:", error);
      setErrorMessage("Error updating profile. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) console.log("Not logged in");
    });
    return () => unsubscribe();
  }, []);

  const access = () => {
    navigate("/verify-account/pendingApproval");
  };

  return (
    <div className="onboarding-container">
      {!showPopup ? (
        <div className="onboarding-card fade-in">
          <FaUser className="user-icon" />
          <h2 className="heading">What should we call you?</h2>
          
          <form onSubmit={handleProfileUpdate}>
            <input
              type="text"
              name="username"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <button type="submit" disabled={isLoading}>
              {isLoading ? <ImSpinner8 className="spinner" /> : "Save Username"}
            </button>
          </form>

          {errorMessage && <p className="error-message">{errorMessage}</p>}
        </div>
      ) : (
        <div className="popup-overlay fade-in">
          <div className="popup">
            <FaCheckCircle className="animated-icon" />
            {/* Updated Heading and Text below */}
            <h2 className="popup-heading">Profile Saved, {username}!</h2>
            <p className="popup-text">Your information has been successfully securely saved and is now being processed by our compliance team.</p>
            <button onClick={access} className="cta-button">
              Continue <FaArrowRight className="arrow-icon" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Onboarding;